/* tslint:disable:no-string-literal */
import {CHART_TYPE} from '../../DoraData/data-base';
import * as Highcharts from 'highcharts';
import {SeriesOptionsType, XAxisOptions} from 'highcharts';
import * as Exporting from 'highcharts/modules/exporting';
import {DataSeries} from '../../DoraData/data-series';
import {ChartOption} from './Data/chart-option';
import {DoraNumber} from '../../Utility/dora-number';


// @ts-ignore
Exporting(Highcharts);


export class ChartBuilder {
    private chartType: CHART_TYPE = null;
    public chart: typeof Highcharts = Highcharts;
    public chartOptions: Highcharts.Options = {};
    private xAxis: ChartOption[] = [];
    private yAxis: ChartOption[] = [];
    private legend: ChartOption[] = [];
    private tooltip: ChartOption[] = [];
    private seriesList: DataSeries[];
    public title = '';
    private customToolTip = false;
    private outputFormat: string;
    private outputFormatFromData: boolean;

    constructor(chartType: CHART_TYPE, graphSkinConfiguration: string,
                seriesList: DataSeries[],
                chart: ChartOption[],
                legend: ChartOption[],
                tooltip: ChartOption[],
                xAxis: ChartOption[], yAxis: ChartOption[],
                plotOptionsForType: ChartOption[],
                title: string,
                customToolTip: boolean,
                outputFormat: string,
                outputFormatFromData: boolean) {

        this.chartType = chartType;
        this.chartOptions = JSON.parse(graphSkinConfiguration);
        this.xAxis = xAxis;
        this.yAxis = yAxis;
        this.legend = legend;
        this.tooltip = tooltip;
        this.title = title;
        this.customToolTip = customToolTip;
        this.outputFormat = outputFormat;
        this.outputFormatFromData = outputFormatFromData;

        switch (this.chartType) {
            case CHART_TYPE.COLUMNSTACK:
                this.chartOptions.chart.type = 'column';
                this.chartOptions.plotOptions = {column: {stacking: 'normal'}};
                this.setOptions(this.chartOptions.plotOptions, 'column', plotOptionsForType);
                break;
            case CHART_TYPE.COLUMN:
                this.chartOptions.chart.type = 'column';
                this.chartOptions.plotOptions = {column: {stacking: undefined}};
                this.setOptions(this.chartOptions.plotOptions, 'column', plotOptionsForType);
                break;
            case CHART_TYPE.BAR:
                this.chartOptions.chart.type = 'bar';
                this.chartOptions.plotOptions = {bar: {}};
                this.setOptions(this.chartOptions.plotOptions, 'bar', plotOptionsForType);
                break;
            case CHART_TYPE.LINEAR:
                this.chartOptions.chart.type = 'line';
                this.chartOptions.plotOptions = {line: {}};
                this.setOptions(this.chartOptions.plotOptions, 'line', plotOptionsForType);
                break;
            case CHART_TYPE.SPLINE:
                this.chartOptions.chart.type = 'spline';
                this.chartOptions.plotOptions = {spline: {}};
                this.setOptions(this.chartOptions.plotOptions, 'spline', plotOptionsForType);
                break;
            case CHART_TYPE.PIE:
                this.chartOptions.chart.type = 'pie';
                // this.chartOptions.plotOptions = {pie: {dataLabels: {enabled: false}}};
                this.setOptions(this.chartOptions.plotOptions, 'pie', plotOptionsForType);
                break;
        }

        this.setOptions(this.chartOptions, 'chart', chart);

        this.createSingleChart(seriesList);
    }

    public getSVG(chartIdx: number): string {
        return this.chart.charts.filter(chart => chart !== undefined)[chartIdx].getSVG();
        // const chartToPrint: Chart = this.chart.charts.find(chart => chart !== undefined);
        //
        // if (chartToPrint !== undefined) {
        //     return chartToPrint.getSVG();
        // } else {
        //     return '';
        // }
    }
    public export(outputType: string): void {
        this.chart.charts.forEach(chartToPrint => {
            if (chartToPrint !== undefined) {
                const exportingOptions: any = this.chart.getOptions().exporting;

                // set output type
                exportingOptions.type = outputType;
                chartToPrint.exportChart(exportingOptions, this.chart.getOptions());

                console.log('Print finished');
            }
        });
    }

    private createSingleChart(seriesList: DataSeries[]): void {
        this.seriesList = seriesList;

        // clone options
        const chartOptions: Highcharts.Options = this.chartOptions;

        // set title
        this.setOption(chartOptions, 'title', ChartOption.create('text', 's', this.title));

        const xAxisOption: XAxisOptions = {};
        xAxisOption.categories = [];

        seriesList[0].TuplasDescription.forEach(tuplaDescription => {
            xAxisOption.categories.push(tuplaDescription.Name);
        });
        chartOptions.xAxis = xAxisOption;

        let firstUnit = '';

        seriesList.forEach(dataSeries => {
            if (firstUnit === '') {
              firstUnit = dataSeries.Units;
            }
            let secondSeries = false;
            let chartType = this.chartType;
            if (dataSeries.Units !== firstUnit) {
              chartType = CHART_TYPE.LINEAR;
              secondSeries = true;
            }

            const chartSeriesElement: SeriesOptionsType = this.getSeriesOptions(chartType);

            chartSeriesElement.name = dataSeries.Description;
            chartSeriesElement.yAxis = secondSeries === true ? 1 : 0;
            chartSeriesElement.tooltip = {valueSuffix: ' ' + dataSeries.Units};
            chartSeriesElement.data = [];

            dataSeries.DataRows.forEach(dataRow => {

                // tslint:disable-next-line:ban-types
                const data = [];

                data.push(dataRow.DataTuplas[0].Value);
                data.push(dataRow.DataTuplas[1].Value);
                if (this.chartType === CHART_TYPE.PIE) {
                    data['name'] = dataRow.DataTuplas[0].Value;
                }

                // Improperly use of className to set outputFormat
                data['className'] =
                  dataRow.DataTuplas[1].OutputFormat === undefined ? this.outputFormat : dataRow.DataTuplas[1].OutputFormat;
                chartSeriesElement.data.push(data);

                // chartSeriesElement.data.push(dataRow.DataTuplas[1].Value);

            });

            chartOptions.series.push(chartSeriesElement);
        });

        // Axis options
        this.setOptions(chartOptions, 'xAxis', this.xAxis);
        this.setOptions(chartOptions, 'yAxis', this.yAxis);

        // legend
        this.setOptions(chartOptions, 'legend', this.legend);

        // tooltip generic
        this.setOptions(chartOptions, 'tooltip', this.tooltip);

        // tooltip
        if (chartOptions.tooltip === undefined) {
            chartOptions.tooltip = {};
        }
        if (this.customToolTip) {
          this.chartOptions.tooltip.useHTML = true;
          this.chartOptions.tooltip.formatter = this.toolTipFormatter;
        }

        this.chart.setOptions(chartOptions);
    }

  private toolTipFormatter(): false | string | Array<string> {
      // @ts-ignore
      const serieName = this.series.getName();
      let result = '<div class="tooltip-container">';
      // @ts-ignore
      result += '<div class="column-name">' + this.point.name + '</div>';
    // @ts-ignore
      result += '<div class="name" style="color:' + this.color + ';">' + serieName + '</div>';

      result += '<div class="value-container">';

    // @ts-ignore
      if (this.series.tooltipOptions.valuePrefix !== undefined) {
        // @ts-ignore
        result += '<span class="valuePrefix">' + this.series.tooltipOptions.valuePrefix + '</span>';
      }

      // get number format
      let outputFormat = '###,###,###.##';

    // @ts-ignore
    // tslint:disable-next-line:prefer-for-of
      for (let i = 0; i < this.series.options.data.length; i++) {
        // @ts-ignore
        if (this.series.options.data[i][0] === this.point.name) {
          // @ts-ignore
          outputFormat = this.series.options.data[i].className;
          break;
        }
      }

      result += '<span class="value">' +



        // @ts-ignore
      DoraNumber.formatNumber(this.y,
      null,
        outputFormat) + '</span>';

    // @ts-ignore
      if (this.series.tooltipOptions.valueSuffix !== undefined) {
        // @ts-ignore
        result += '<span class="valueSuffix">' + this.series.tooltipOptions.valueSuffix + '</span>';
      }

      result += '</div>';
      result += '</div>';

      return result;
  }

  private getUnit(seriesName: string): string {
      return 'ciao';
  }

  /**
   * Get specific chartoptions depending on chartType
   * @param chartType type of chart
   */
  private getSeriesOptions(chartType: CHART_TYPE): SeriesOptionsType {
        switch (chartType) {
            case CHART_TYPE.COLUMN:
            case CHART_TYPE.COLUMNSTACK:
                return {type: 'column'};
            case CHART_TYPE.LINEAR:
                return {type: 'line'};
            case CHART_TYPE.SPLINE:
                return {type: 'spline'};
            case CHART_TYPE.BAR:
                return {type: 'bar'};
            case CHART_TYPE.PIE:
                return {type: 'pie'};
            default:
                return {type: 'line'};
        }
    }

  // tslint:disable-next-line:ban-types
    private testyAxis(dst: Object): void {
      dst['chart']['marginRight'] = 200;
      dst['yAxis'] = [];
      dst['yAxis'][0] = {};
      dst['yAxis'][1] = {};
      dst['yAxis'][0]['gridLineColor'] = '#197F07';
      dst['yAxis'][1]['opposite'] = true;
      dst['yAxis'][1]['title'] = {};
      dst['yAxis'][1]['title']['text'] = 'secondo valore';
      dst['yAxis'][1]['labels'] = {};
      dst['yAxis'][1]['labels']['enabled'] = true;
      dst['yAxis'][1]['labels']['padding'] = 20;
      dst['yAxis'][1]['labels']['margin'] = 20;
    }
    // tslint:disable-next-line:ban-types
    private setOptions(dst: Object, root: string, options: ChartOption[]): void {
        // if (dst[root] === undefined) {
        //     dst[root] = {};
        // }
        options.forEach((option: ChartOption) => {
            option.setOption(dst, root);
        });
    }

    // tslint:disable-next-line:ban-types
    private setOption(dst: Object, root: string, option: ChartOption): void {
        // if (dst[root] === undefined) {
        //     dst[root] = {};
        // }

        option.setOption(dst, root);
    }

}
